const API_NODE = process.env.REACT_APP_API_NODE;

export const paths = {
  quality: {
    getNextReturnReceiptId: `${API_NODE}/quality/getNextReturnReceiptId`,
    createReturnReceipt: `${API_NODE}/quality/createReturnReceipt`,
    uploadPicture: `${API_NODE}/quality/uploadPicture`,
    delete: `${API_NODE}/quality/deleteReturnReceipt`
  },
  contact: {
    listContact: `${API_NODE}/contacts`,
    contactInfo: `${API_NODE}/contacts/contactInfo`,
    sendMail: `${API_NODE}/contacts/email`,
    sendMailToSuppliers: `${API_NODE}/contacts/emailToSuppliers`
  },
  invoices: {
    uploadXml: `${API_NODE}/invoices/uploadXml`
  }
};
